// @ts-nocheck
import React from 'react';

const baseWrap = [
  'flex items-center w-full',
  'bg-mov-paper-2',
  'border border-mov-line-strong rounded-md2',
  'transition-[border-color,box-shadow,background] duration-150',
  'mov-input-hover mov-input-focus',
].join(' ');

const errorRing = 'mov-input-invalid';

/**
 * Input — bordered text field with optional prefix/suffix/leftIcon slots.
 * Mirrors the reference `.input-grp` style.
 */
const Input = React.forwardRef(({
  prefix,
  suffix,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  className = '',
  invalid,
  inputClassName = '',
  ...rest
}, ref) => (
  <div className={[baseWrap, invalid ? errorRing : '', className].join(' ')}>
    {prefix && (
      <span
        className="mov-mono px-2.5 text-mov-ink-mute self-stretch grid place-items-center"
        style={{ fontSize: 11.5, borderRight: '1px solid var(--mov-line)' }}
      >
        {prefix}
      </span>
    )}
    {LeftIcon && (
      <span className="pl-3 pr-1 text-mov-ink-mute grid place-items-center" aria-hidden="true">
        <LeftIcon size={14} />
      </span>
    )}
    <input
      ref={ref}
      className={[
        'flex-1 min-w-0 border-0 bg-transparent outline-none',
        'px-3 py-2.5 text-[13px] text-mov-ink',
        'placeholder:text-mov-ink-mute',
        inputClassName,
      ].join(' ')}
      {...rest}
    />
    {RightIcon && (
      <span className="pl-1 pr-3 text-mov-ink-mute grid place-items-center" aria-hidden="true">
        <RightIcon size={14} />
      </span>
    )}
    {suffix && (
      <span
        className="mov-mono px-2.5 text-mov-ink-mute self-stretch grid place-items-center"
        style={{ fontSize: 11.5, borderLeft: '1px solid var(--mov-line)' }}
      >
        {suffix}
      </span>
    )}
  </div>
));
Input.displayName = 'Input';

export default Input;
